export enum ActifNonActif {
    'NON ACTIF', 'ACTIF'
}
